import React from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { Theme, ThemeProps } from '@theme/base';
import { mq } from '@styles/breakpoints';
import { Icons } from '@model/common/icons';
import { Included } from '@model/tours';
import { TestId } from '@components/test-ids';
import { Icon } from '@components/common/generic-icon';

/* ***************** *
 *       Types       *
 * ***************** */
export interface WhatsIncludedProps {
  theme?: Theme;
  testId?: string;
  whatsIncluded: Array<Included>;
  columns?: number;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const IncludedContainer = styled.div({
  display: 'flex',
  flexWrap: 'wrap'
});

interface IncludedItemProps extends ThemeProps {
  columns: number;
}
const IncludedItem: any = styled.div(({ theme, columns }: IncludedItemProps) => ({
  ...(theme.custom.typography.paragraph as any),
  alignItems: 'center',
  display: 'flex',
  marginBottom: 0,
  paddingRight: theme.custom.spacing.medium,
  width: '100%',
  [mq.small]: {
    width: `${100 / columns}%`
  }
}));

interface IncludedIconProps extends ThemeProps {
  included: boolean;
}
const IncludedIcon: any = styled(Icon)(({ theme, included }: IncludedIconProps) => ({
  color: included ? theme.custom.colors.group5.base : theme.custom.colors.group11.base,
  fontSize: '1.4rem',
  marginRight: theme.custom.spacing.small
}));

/* *********************** *
 *    WhatsIncludedComponent    *
 * *********************** */

export const WhatsIncludedComponent = ({ whatsIncluded, columns = 3, testId }: WhatsIncludedProps) => {
  return (
    <IncludedContainer data-testid={testId || TestId.whatsIncluded.main}>
      {whatsIncluded.map(({ item, included }) => (
        <IncludedItem key={item} columns={columns}>
          <IncludedIcon name={included ? Icons.CHECK : Icons.CLEAR} included={included} />
          <span>{item}</span>
        </IncludedItem>
      ))}
    </IncludedContainer>
  );
};

export const WhatsIncluded = withTheme(WhatsIncludedComponent);
